import { render, staticRenderFns } from "./BtnAtualizarHistoricos.vue?vue&type=template&id=070ac04e&"
import script from "./BtnAtualizarHistoricos.vue?vue&type=script&lang=js&"
export * from "./BtnAtualizarHistoricos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports